module.exports = __webpack_public_path__ + "img/membership-registration.1d5ba093.png";